import { Route, Routes } from "react-router-dom";
import { employer } from "../globals/route-names";
import EmpDashboardPage from "../app/pannels/employer/components/emp-dashboard";
import EmpCompanyProfilePage from "../app/pannels/employer/components/emp-company-profile";
import EmpPostAJobPage from "../app/pannels/employer/components/jobs/emp-post-a-job";
import EmpManageJobsPage from "../app/pannels/employer/components/jobs/emp-manage-jobs";
import EmpCandidatesPage from "../app/pannels/employer/components/emp-candidates";
import EmpBookmarksPage from "../app/pannels/employer/components/emp-bookmarks";
import EmpSubscriptionPage from "../app/pannels/employer/components/emp-subscription";
import EmpEmailsPage from "../app/pannels/employer/components/emp-emails";
import EmpEmailsEditPage from "../app/pannels/employer/components/emp-emails-edit";
import EmpEmailsAddPage from "../app/pannels/employer/components/emp-emails-add";
import EmpCanAddPage from "../app/pannels/employer/components/emp-can-add";
import EmpPaymentsPage from "../app/pannels/employer/components/emp-payments";
import EmpUserMessagePage from "../app/pannels/employer/components/emp-user-messages";
import EmpRequestPage from "../app/pannels/employer/components/emp-request";
import EmpChangePasswordPage from "../app/pannels/employer/components/emp-change-password";
import EmpMessages1Page from "../app/pannels/employer/components/messages/emp-messages1";
import EmpMessages2Page from "../app/pannels/employer/components/messages/emp-messages2";
import EmpResumeAlertsPage from "../app/pannels/employer/components/emp-resume-alerts";
import EmpSubscriptionEditPage from "../app/pannels/employer/components/emp-subscription-edit";
import EmpSubscriptionAddPage from "../app/pannels/employer/components/emp-subscription-add";
import EmpCandidatesEditPage from "../app/pannels/employer/components/emp-candidates-edit";
import Error404Page from "../app/pannels/public-user/components/pages/error404";

function EmployerRoutes() {
    return (
        <Routes>
            <Route path={employer.DASHBOARD} element={<EmpDashboardPage />} />
            <Route path={employer.PROFILE} element={<EmpCompanyProfilePage />} />
            <Route path={employer.POST_A_JOB} element={<EmpPostAJobPage />} />
            <Route path={employer.MANAGE_JOBS} element={<EmpManageJobsPage />} />
            <Route path={employer.CANDIDATES} element={<EmpCandidatesPage />} />
            <Route path={employer.BOOKMARKS} element={<EmpBookmarksPage />} />
            <Route path={employer.SUBSCRIPTION} element={<EmpSubscriptionPage />} />
            <Route path={employer.EMAILS} element={<EmpEmailsPage />} />
            <Route path={employer.EMAILS_EDIT} element={<EmpEmailsEditPage />} />
            <Route path={employer.EMAILS_ADD} element={<EmpEmailsAddPage />} />
            <Route path={employer.CANDIDATE_ADD} element={<EmpCanAddPage />} />
            <Route path={employer.PAYMENTS} element={<EmpPaymentsPage />} />
            <Route path={employer.USERMESSAGES} element={<EmpUserMessagePage />} />
            <Route path={employer.REQUEST} element={<EmpRequestPage />} />
            <Route path={employer.CHANGE_PASSWORD} element={<EmpChangePasswordPage />} />
            <Route path={employer.MESSAGES1} element={<EmpMessages1Page />} />
            <Route path={employer.MESSAGES2} element={<EmpMessages2Page />} />
            <Route path={employer.RESUME_ALERTS} element={<EmpResumeAlertsPage />} />
            <Route path={employer.SUBSCRIPTION_EDIT} element={<EmpSubscriptionEditPage />} />
            <Route path={employer.SUBSCRIPTION_ADD} element={<EmpSubscriptionAddPage />} />
            <Route path={employer.CANDIDATES_EDIT} element={<EmpCandidatesEditPage />} />
            <Route path="*" element={<Error404Page />} />
        </Routes>
    )
}

export default EmployerRoutes;